module.exports = __webpack_public_path__ + "img/let-me-hear-a-rhyme.3a3b7fb9.png";